
import { Flex } from '@chakra-ui/react';
import  colors  from 'core/resources/theme/colors';

export default function HeaderTable(){
    return(
        <Flex bg={colors.black75} roundedTop={15} px={4} h='60px' align='center'>
            <Flex flex={2} fontWeight='medium'>Item</Flex>
            <Flex flex={1.5} fontWeight='medium'>Medida</Flex>
            <Flex flex={1} fontWeight='medium'>Quantidade</Flex>
            <Flex flex={1} fontWeight='medium'>Valor Unitário</Flex>
            <Flex flex={1} fontWeight='medium' justifyContent="flex-end" mr='100px'>Total</Flex>
        </Flex>
    )
}